import { z } from 'zod';

export type HardwareCSVParser = typeof import('./CSVParsingWorker');
export type Result = Awaited<ReturnType<HardwareCSVParser['processAnyCSV']>>;

export const hardwareDescription = [
  'DeviceType',
  'Make',
  'Model',
  'Processor',
  'Memory',
  'Storage',
  'ScreenSize',
  'SerialNumber'
];
export const HardwareDescription = z.object({
  [hardwareDescription[0]]: z.string().optional(),
  [hardwareDescription[1]]: z.string().optional(),
  [hardwareDescription[2]]: z.string().optional(),
  [hardwareDescription[3]]: z.string().optional(),
  [hardwareDescription[4]]: z.string().optional(),
  [hardwareDescription[5]]: z.string().optional(),
  [hardwareDescription[6]]: z.string().optional(),
  [hardwareDescription[7]]: z.string().optional()
});
export type HardwareDescription = z.infer<typeof HardwareDescription>;

export const createTemplate = () => {
  const examples = [
    [
      'Laptop',
      'Dell',
      'Precision 3580 Workstation',
      '13th Gen Intel® Core™ i7-1360P',
      '16GB',
      '512 GB',
      '15.6" FHD 1920 x 1080',
      'ab4537145587'
    ]
  ];

  const head = hardwareDescription.join(',');
  return examples.reduce((template, row) => {
    return template + '\n' + row.join(',');
  }, head);
};
